<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    Saldo PIX: <span class="font-bold">R$ {{ qrCodes.balance.value | currency }}</span>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    QR Codes PIX registrados
                </h2>
            </div>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                    <flash :timeout="5000"/>
                    <inertia-table
                        class="text-xs"
                        :data="qrCodes"
                        :params="params"
                        :filters="filters"
                        :columns="columns"
                        id="id"
                        routeName="qr-codes.index"
                        @item-selected="show">
                        <template slot-scope="row" slot="payer.name">
                            <div class="text-left">{{ row.item.payer.name || '-' }}</div>
                        </template>
                        <template slot-scope="row" slot="conciliation_id">
                            <div class="text-center">{{ row.item.conciliation_id || '-' }}</div>
                        </template>
                        <template slot-scope="row" slot="created">
                            <div class="text-center">{{ row.item.created | smallDate }}</div>
                        </template>
                        <template slot-scope="row" slot="expiration_date">
                            <div class="text-center">{{ row.item.expiration_date | smallDate }}</div>
                        </template>
                        <template slot-scope="row" slot="amount">
                            <div class="text-right">{{ row.item.amount | currency }}</div>
                        </template>
                        <template slot-scope="row" slot="status">
                            <div class="text-center">{{ statusList[row.item.status] }}</div>
                        </template>
                    </inertia-table>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout';
import Welcome from './../../Jetstream/Welcome';
import Dropdown from '../../Jetstream/Dropdown';
import DropdownLink from '../../Jetstream/DropdownLink';
import JetAutoComplete from '../../Jetstream/AutoComplete';
import Flash from '../../Helpers/Flash';
import InertiaTable from '../../Helpers/Tables/InertiaTable';

export default {
    components: {
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable
    },
    props: ['qr-codes'],
    data() {
        return {
            columns: [
                {text: 'Pagador', className: 'text-left', key: 'payer.name', sortable: true},
                {text: 'Código Conciliação', className: 'text-center', key: 'conciliation_id', sortable: true},
                {text: 'Dt. Emissão', className: 'text-center', key: 'created', sortable: true},
                {text: 'Dt. Vencimento', className: 'text-center', key: 'expiration_date', sortable: true},
                {text: 'Valor', className: 'text-right', key: 'amount', sortable: true},
                {text: 'Status', className: 'text-center', key: 'status', sortable: true},
            ],
            filters: [
                {
                    text: 'Status',
                    key: 'status',
                    type: 'dropdown',
                    options: [
                        {id: 'pending', name: 'Pendente'},
                        {id: 'error', name: 'Erro de registro'},
                        {id: 'registered', name: 'Registrado'},
                        {id: 'paid', name: 'Pago'},
                        {id: 'expired', name: 'Vencido'},
                        {id: 'canceled', name: 'Cancelado'},
                    ]
                }
            ],
            statusList: {
                pending: 'Pendente',
                error: 'Erro',
                registered: 'Registrado',
                paid: 'Pago',
                expired: 'Vencido',
                canceled: 'Cancelado'
            },
            params: {
                sort: 'expiration_date:desc',
                page: 1,
                ...this.$page.props.queryString
            },
        }
    },
    methods: {
        show: function (item) {
            this.$inertia.get(this.route('qr-codes.show', item.id));
        }
    }
}


</script>
